document.addEventListener('buybox:variantChanged', function (event) {
    const variant = event.detail.data;

    const skuEl = document.querySelectorAll('[data-sku]');
    if (skuEl) {
        if (variant && variant.sku) {
            skuEl.forEach((el) => {

                el.textContent = variant.sku;
            })
        }
    }

});

(function() {
    const getOriginIndex = (element, fallbackIndex) => {
        const parsedIndex = Number.parseInt(element.dataset.originIndex || '', 10);

        if (!Number.isNaN(parsedIndex)) {
            return parsedIndex;
        }

        return fallbackIndex;
    };

    const sortByOriginIndex = (left, right) => getOriginIndex(left, 0) - getOriginIndex(right, 0);

    const getFeaturedFirstOrder = (items, featuredOriginIndex) => {
        const orderedItems = items.slice().sort(sortByOriginIndex);
        const featuredIndex = orderedItems.findIndex((item) => getOriginIndex(item, -1) === featuredOriginIndex);

        if (featuredIndex <= 0) {
            return orderedItems;
        }

        const featuredItem = orderedItems.splice(featuredIndex, 1)[0];
        orderedItems.unshift(featuredItem);

        return orderedItems;
    };

    const appendOrderedChildren = (container, primaryChildren, trailingChildren = []) => {
        primaryChildren.forEach((child) => {
            container.appendChild(child);
        });

        trailingChildren.forEach((child) => {
            container.appendChild(child);
        });
    };

    const patchQuickviewClickTargets = (galleryInstance, elements) => {
        elements.forEach((element) => {
            if (!element || element.dataset.quickviewClickPatched === 'true') return;

            element.addEventListener('click', (event) => {
                const originIndex = Number.parseInt(element.dataset.originIndex || '', 10);
                if (Number.isNaN(originIndex)) return;

                event.preventDefault();
                event.stopImmediatePropagation();

                if (typeof galleryInstance.goToSlide === 'function') {
                    galleryInstance.goToSlide(originIndex);
                }
            }, true);

            element.dataset.quickviewClickPatched = 'true';
        });
    };

    const normalizeQuickviewGalleryOrder = (galleryInstance, startAt) => {
        const quickviewRoot = document.getElementById('productQuickViewTemplate');
        if (!quickviewRoot) return;

        const galleryRoot = quickviewRoot.querySelector('[data-pg]');
        const mainSlides = galleryRoot ? galleryRoot.querySelector('[data-pg-main-slides]') : null;
        const thumbSlides = galleryRoot ? galleryRoot.querySelector('[data-pg-thumb-slides]') : null;
        const zoomSlides = galleryRoot ? galleryRoot.querySelector('[data-pg-zoom-slides]') : null;
        const dotSlides = galleryRoot ? galleryRoot.querySelector('[data-pg-dots]') : null;

        if (!mainSlides || !thumbSlides || !zoomSlides || !dotSlides) return;

        const imageSlides = Array.from(mainSlides.children).filter((slide) => slide.classList.contains('product-image'));
        if (imageSlides.length === 0) return;

        const videoSlides = Array.from(mainSlides.children).filter((slide) => slide.classList.contains('product-video'));

        const thumbImages = Array.from(thumbSlides.children).filter((slide) => slide.tagName === 'IMG');
        const thumbVideos = Array.from(thumbSlides.children).filter((slide) => slide.classList.contains('thumbnail--video'));
        const zoomImages = Array.from(zoomSlides.children).filter((slide) => slide.classList.contains('zoom-image'));
        const dots = Array.from(dotSlides.children).filter((dot) => !dot.classList.contains('dot--video'));
        const videoDots = Array.from(dotSlides.children).filter((dot) => dot.classList.contains('dot--video'));

        imageSlides.forEach((slide, index) => {
            const originIndex = slide.dataset.originIndex || String(index);

            if (thumbImages[index]) {
                thumbImages[index].dataset.originIndex = originIndex;
            }

            if (zoomImages[index]) {
                zoomImages[index].dataset.originIndex = originIndex;
            }

            if (dots[index]) {
                dots[index].dataset.originIndex = originIndex;
            }
        });

        const featuredOriginIndex = Number.isInteger(startAt) ? startAt : Number.parseInt(startAt, 10);
        const orderedImageSlides = getFeaturedFirstOrder(imageSlides, featuredOriginIndex);
        const orderedThumbImages = getFeaturedFirstOrder(thumbImages, featuredOriginIndex);
        const orderedZoomImages = getFeaturedFirstOrder(zoomImages, featuredOriginIndex);
        const orderedDots = getFeaturedFirstOrder(dots, featuredOriginIndex);

        appendOrderedChildren(mainSlides, orderedImageSlides, videoSlides);
        appendOrderedChildren(thumbSlides, orderedThumbImages, thumbVideos);
        appendOrderedChildren(zoomSlides, orderedZoomImages);
        appendOrderedChildren(dotSlides, orderedDots, videoDots);

        patchQuickviewClickTargets(galleryInstance, orderedThumbImages);
        patchQuickviewClickTargets(galleryInstance, orderedDots);

        if (galleryInstance.pgGlide && typeof galleryInstance.pgGlide.update === 'function') {
            galleryInstance.pgGlide.update();
        }

        if (galleryInstance.pgGlide) {
            galleryInstance.pgGlide.go('=0');
        }

        resetQuickviewThumbRail(galleryInstance);

        if (typeof galleryInstance.setActiveDotAndThumb === 'function' && galleryInstance.pgGlide) {
            galleryInstance.setActiveDotAndThumb(galleryInstance.pgGlide.index);
        }

        if (typeof galleryInstance.disableThumbnailButtons === 'function') {
            galleryInstance.disableThumbnailButtons();
        }
    };

    const resetQuickviewThumbRail = (galleryInstance) => {
        if (!galleryInstance || !galleryInstance.pgThumbGlide || !galleryInstance.thumbSlides) return;

        const thumbCount = galleryInstance.thumbSlides.children.length;
        const visibleThumbs = thumbCount > 0 ? Math.min(thumbCount, 10) : 10;
        const thumbHeight = 72;

        const getThumbWidth = (thumb) => {
            if (!thumb) return thumbHeight;

            const thumbImage = thumb.tagName === 'IMG' ? thumb : thumb.querySelector('img');
            if (!thumbImage) return thumbHeight;

            const naturalWidth = Number.parseFloat(thumbImage.getAttribute('width')) || thumbImage.naturalWidth || 0;
            const naturalHeight = Number.parseFloat(thumbImage.getAttribute('height')) || thumbImage.naturalHeight || 0;

            if (!naturalWidth || !naturalHeight) {
                return thumbHeight;
            }

            return Math.max(Math.round((naturalWidth / naturalHeight) * thumbHeight), 32);
        };

        if (typeof galleryInstance.pgThumbGlide.update === 'function') {
            galleryInstance.pgThumbGlide.update({
                perView: visibleThumbs,
                startAt: 0,
                focusAt: 0,
                bound: thumbCount > visibleThumbs
            });
        }

        if (typeof galleryInstance.pgThumbGlide.go === 'function') {
            galleryInstance.pgThumbGlide.go('=0');
        }

        if (thumbCount <= 10) {
            galleryInstance.thumbSlides.style.transform = 'translate3d(0px, 0px, 0px)';
            galleryInstance.thumbSlides.style.justifyContent = 'flex-start';
            galleryInstance.thumbSlides.style.width = 'auto';

            Array.from(galleryInstance.thumbSlides.children).forEach((thumb) => {
                const thumbWidth = getThumbWidth(thumb);

                thumb.style.width = `${thumbWidth}px`;
                thumb.style.minWidth = `${thumbWidth}px`;
                thumb.style.flex = `0 0 ${thumbWidth}px`;
                thumb.style.height = `${thumbHeight}px`;
            });
        }
    };

    const patchQuickviewGalleryBuild = () => {
        if (!window.eHS || !window.eHS.quickviewProductGallery) return false;

        const galleryInstance = window.eHS.quickviewProductGallery;
        if (galleryInstance.__quickviewOrderPatched || typeof galleryInstance.build !== 'function') {
            return true;
        }

        const originalBuild = galleryInstance.build;
        galleryInstance.build = function(color, startAt) {
            const result = originalBuild.call(this, color, startAt);

            window.setTimeout(() => {
                normalizeQuickviewGalleryOrder(this, startAt);
            }, 260);

            return result;
        };

        if (typeof galleryInstance.initGlide === 'function' && !galleryInstance.__quickviewInitPatched) {
            const originalInitGlide = galleryInstance.initGlide;
            galleryInstance.initGlide = function(startAt) {
                const result = originalInitGlide.call(this, startAt);

                window.setTimeout(() => {
                    resetQuickviewThumbRail(this);
                }, 0);

                return result;
            };

            galleryInstance.__quickviewInitPatched = true;
        }

        if (typeof galleryInstance.setActiveDotAndThumb === 'function' && !galleryInstance.__quickviewThumbPatched) {
            const originalSetActiveDotAndThumb = galleryInstance.setActiveDotAndThumb;
            galleryInstance.setActiveDotAndThumb = function(index) {
                const result = originalSetActiveDotAndThumb.call(this, index);
                resetQuickviewThumbRail(this);
                return result;
            };

            galleryInstance.__quickviewThumbPatched = true;
        }

        galleryInstance.__quickviewOrderPatched = true;
        return true;
    };

    if (patchQuickviewGalleryBuild()) return;

    const patchInterval = window.setInterval(() => {
        if (patchQuickviewGalleryBuild()) {
            window.clearInterval(patchInterval);
        }
    }, 200);

    window.setTimeout(() => {
        window.clearInterval(patchInterval);
    }, 10000);
})();

(function() {
    const QUICKVIEW_ROOT_SELECTOR = '#productQuickViewTemplate';

    const inferVideoProvider = (iframe) => {
        if (!iframe) return null;

        if (iframe.dataset.videoProvider) {
            return iframe.dataset.videoProvider;
        }

        const src = iframe.getAttribute('src') || '';
        if (src.indexOf('youtube.com/embed/') !== -1) {
            iframe.dataset.videoProvider = 'youtube';
            return 'youtube';
        }

        if (src.indexOf('player.vimeo.com/video/') !== -1 || src.indexOf('vimeo.com/') !== -1) {
            iframe.dataset.videoProvider = 'vimeo';
            return 'vimeo';
        }

        return null;
    };

    const updateEmbedSrc = (iframe) => {
        if (!iframe || iframe.dataset.videoEmbedReady === 'true') return;

        const src = iframe.getAttribute('src');
        if (!src) return;

        let updatedSrc = src;
        if (src.indexOf('youtube.com/embed/') !== -1) {
            if (updatedSrc.indexOf('enablejsapi=1') === -1) {
                updatedSrc += (updatedSrc.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1';
            }
            if (updatedSrc.indexOf('controls=0') === -1) {
                updatedSrc += '&controls=0';
            }
            iframe.dataset.videoProvider = 'youtube';
        } else if (src.indexOf('player.vimeo.com/video/') !== -1 || src.indexOf('vimeo.com/') !== -1) {
            if (updatedSrc.indexOf('api=1') === -1) {
                updatedSrc += (updatedSrc.indexOf('?') === -1 ? '?' : '&') + 'api=1';
            }
            iframe.dataset.videoProvider = 'vimeo';
        }

        if (updatedSrc !== src) {
            iframe.setAttribute('src', updatedSrc);
        }

        iframe.dataset.videoEmbedReady = 'true';
    };

    const postEmbedCommand = (iframe, command) => {
        const provider = inferVideoProvider(iframe);
        if (!iframe || !provider || !iframe.contentWindow) return;

        if (provider === 'youtube') {
            iframe.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: command === 'play' ? 'playVideo' : 'pauseVideo',
                args: []
            }), '*');
        }

        if (provider === 'vimeo') {
            iframe.contentWindow.postMessage(JSON.stringify({
                method: command
            }), '*');
        }
    };

    const setPlayingState = (container, isPlaying) => {
        if (!container) return;

        container.classList.toggle('is-playing', isPlaying);
        container.dataset.videoPlaying = isPlaying ? 'true' : 'false';
    };

    const pauseContainer = (container) => {
        if (!container) return;

        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        if (video && !video.paused) {
            video.pause();
        }

        if (iframe) {
            postEmbedCommand(iframe, 'pause');
        }

        setPlayingState(container, false);
    };

    const pauseOtherQuickviewVideos = (activeContainer) => {
        document.querySelectorAll(`${QUICKVIEW_ROOT_SELECTOR} .product-video`).forEach((container) => {
            if (container !== activeContainer) {
                pauseContainer(container);
            }
        });
    };

    const toggleQuickviewVideo = (container) => {
        if (!container) return;

        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        pauseOtherQuickviewVideos(container);

        if (video) {
            video.controls = false;

            if (video.paused) {
                const playPromise = video.play();
                if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.then(() => {
                        setPlayingState(container, true);
                    }).catch(() => {
                        setPlayingState(container, false);
                    });
                } else {
                    setPlayingState(container, true);
                }
            } else {
                video.pause();
                setPlayingState(container, false);
            }

            return;
        }

        if (iframe) {
            updateEmbedSrc(iframe);

            const isPlaying = container.dataset.videoPlaying === 'true';
            postEmbedCommand(iframe, isPlaying ? 'pause' : 'play');
            setPlayingState(container, !isPlaying);
        }
    };

    document.addEventListener('click', (event) => {
        const toggle = event.target.closest(`${QUICKVIEW_ROOT_SELECTOR} [data-video-toggle]`);
        if (!toggle) return;

        const container = toggle.closest('.product-video');
        if (!container) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        toggleQuickviewVideo(container);
    }, true);

    document.addEventListener('click', (event) => {
        if (!event.target.closest('#quickshop-modal .modal-close')) return;

        document.querySelectorAll(`${QUICKVIEW_ROOT_SELECTOR} .product-video`).forEach(pauseContainer);
    }, true);
})();

(function() {
    const swatchCache = new Map();

    const handleize = (value) => String(value || '')
        .toLowerCase()
        .replace(/["'\\()\[\]$]/g, '')
        .replace(/\W+/g, '-')
        .replace(/^-+|-+$/g, '');

    const getQuickviewJsonUrl = (handle, storefront, language) => {
        if (storefront === 'CA' && language === 'fr') {
            return `https://pearlizumi-ca.myshopify.com/fr/products/${handle}?view=json`;
        }

        return `/products/${handle}?view=json`;
    };

    const normalizeColorSwatches = (buyBox, root) => {
        if (!root) return;

        const colorSwatches = Array.from(root.querySelectorAll('[data-color-option]'));
        const product = buyBox && buyBox.product;
        const productOptions = product && Array.isArray(product.options) ? product.options : [];
        const colorOptionName = buyBox && buyBox.colorOptionName ? buyBox.colorOptionName : 'color';
        const colorOptionIndex = productOptions.findIndex((optionName) => handleize(optionName) === handleize(colorOptionName));
        const currentVariant = buyBox && buyBox.currentVariant ? buyBox.currentVariant : null;
        const currentColorValue = currentVariant && colorOptionIndex >= 0
            ? handleize(currentVariant.options[colorOptionIndex])
            : '';

        colorSwatches.forEach((button) => {
            let shouldShowDisabledState = button.classList.contains('disabled') || button.disabled || button.getAttribute('aria-disabled') === 'true';

            if (product && Array.isArray(product.variants) && colorOptionIndex >= 0) {
                const variantsWithColor = product.variants.filter((variant) =>
                    handleize(variant.options[colorOptionIndex]) === button.dataset.value
                );

                shouldShowDisabledState = variantsWithColor.length > 0 && variantsWithColor.every((variant) => !variant.available);
            }

            if (!shouldShowDisabledState && currentVariant && !currentVariant.available && currentColorValue === button.dataset.value) {
                shouldShowDisabledState = true;
            }

            button.classList.toggle('disabled', shouldShowDisabledState);
            button.disabled = false;
            button.removeAttribute('disabled');
            button.removeAttribute('aria-disabled');
        });
    };

    const applyQuickviewSwatches = (quickviewRoot, swatches, colorOptionName, attempts = 0) => {
        if (!quickviewRoot || !Array.isArray(swatches) || !swatches.length) return;

        const swatchButtons = Array.from(quickviewRoot.querySelectorAll('[data-color-option]'));
        if (!swatchButtons.length) {
            if (attempts < 10) {
                window.setTimeout(() => {
                    applyQuickviewSwatches(quickviewRoot, swatches, colorOptionName, attempts + 1);
                }, 120);
            }
            return;
        }

        swatches.forEach((swatch) => {
            if (!swatch || !swatch.master) return;

            const button = swatchButtons.find((candidate) =>
                candidate.dataset.option === colorOptionName && candidate.dataset.value === handleize(swatch.name)
            );

            if (!button) return;

            const swatchInner = button.querySelector('div');
            if (!swatchInner) return;

            swatchInner.style.background = `url(${swatch.master}) center/contain`;
            swatchInner.style.backgroundRepeat = 'no-repeat';
        });

        normalizeColorSwatches(window.eHS && window.eHS.quickviewProductBuyBox, quickviewRoot);
    };

    const fetchQuickviewSwatches = (handle, storefront, language) => {
        const cacheKey = `${storefront || 'default'}:${language || 'default'}:${handle}`;

        if (!swatchCache.has(cacheKey)) {
            const request = fetch(getQuickviewJsonUrl(handle, storefront, language), {
                credentials: 'same-origin'
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Quickview swatch fetch failed with status ${response.status}`);
                    }

                    return response.json();
                })
                .then((product) => Array.isArray(product && product.swatches) ? product.swatches : [])
                .catch((error) => {
                    swatchCache.delete(cacheKey);
                    throw error;
                });

            swatchCache.set(cacheKey, request);
        }

        return swatchCache.get(cacheKey);
    };

    const patchQuickviewSwatchData = () => {
        if (!window.eHS || !window.eHS.quickviewProductBuyBox) return false;

        const buyBox = window.eHS.quickviewProductBuyBox;
        if (buyBox.__quickviewSwatchDataPatched || typeof buyBox.setSwatchData !== 'function') {
            return true;
        }

        const originalSetSwatchData = buyBox.setSwatchData;
        buyBox.setSwatchData = function() {
            const result = originalSetSwatchData.apply(this, arguments);
            const quickviewRoot = this.mainWrapper || document.getElementById('productQuickViewTemplate');

            if (!quickviewRoot || !this.productHandle) {
                return result;
            }

            fetchQuickviewSwatches(this.productHandle, this.storefront, this.language)
                .then((swatches) => {
                    if (this.product && Array.isArray(swatches) && swatches.length) {
                        this.product.swatches = swatches;
                    }

                    applyQuickviewSwatches(quickviewRoot, swatches, this.colorOptionName || 'color');
                })
                .catch((error) => {
                    console.error('Quickview swatch override failed.', error);
                });

            return result;
        };

        buyBox.__quickviewSwatchDataPatched = true;
        return true;
    };

    const patchQuickviewClickableColorSwatches = () => {
        if (!window.eHS || !window.eHS.quickviewProductBuyBox) return false;

        const buyBox = window.eHS.quickviewProductBuyBox;
        if (buyBox.__quickviewClickableColorSwatchesPatched) {
            return true;
        }

        const syncColorSwatches = () => {
            const quickviewRoot = buyBox.mainWrapper || document.getElementById('productQuickViewTemplate');
            normalizeColorSwatches(buyBox, quickviewRoot);
        };

        if (typeof buyBox.updateOptionButtons === 'function') {
            const originalUpdateOptionButtons = buyBox.updateOptionButtons;
            buyBox.updateOptionButtons = function() {
                const result = originalUpdateOptionButtons.apply(this, arguments);
                syncColorSwatches();
                return result;
            };
        }

        if (typeof buyBox.initOutOfStock === 'function') {
            const originalInitOutOfStock = buyBox.initOutOfStock;
            buyBox.initOutOfStock = function() {
                const result = originalInitOutOfStock.apply(this, arguments);
                syncColorSwatches();
                return result;
            };
        }

        window.setTimeout(syncColorSwatches, 0);

        buyBox.__quickviewClickableColorSwatchesPatched = true;
        return true;
    };

    const patchPdpClickableColorSwatches = () => {
        const productRoot = document.getElementById('productTemplate');
        if (!productRoot || !window.eHS || !window.eHS.productBuyBox) return false;

        const buyBox = window.eHS.productBuyBox;
        if (buyBox.__pdpClickableColorSwatchesPatched) {
            return true;
        }

        const syncColorSwatches = () => {
            normalizeColorSwatches(buyBox, productRoot);
        };

        if (typeof buyBox.updateOptionButtons === 'function') {
            const originalUpdateOptionButtons = buyBox.updateOptionButtons;
            buyBox.updateOptionButtons = function() {
                const result = originalUpdateOptionButtons.apply(this, arguments);
                syncColorSwatches();
                return result;
            };
        }

        if (typeof buyBox.initOutOfStock === 'function') {
            const originalInitOutOfStock = buyBox.initOutOfStock;
            buyBox.initOutOfStock = function() {
                const result = originalInitOutOfStock.apply(this, arguments);
                syncColorSwatches();
                return result;
            };
        }

        window.setTimeout(syncColorSwatches, 0);

        buyBox.__pdpClickableColorSwatchesPatched = true;
        return true;
    };

    const patchColorSwatches = () => {
        const quickviewReady = !window.eHS || !window.eHS.quickviewProductBuyBox
            ? true
            : patchQuickviewSwatchData() && patchQuickviewClickableColorSwatches();
        const pdpReady = !document.getElementById('productTemplate')
            ? true
            : patchPdpClickableColorSwatches();

        return quickviewReady && pdpReady;
    };

    if (patchColorSwatches()) return;

    const patchInterval = window.setInterval(() => {
        if (patchColorSwatches()) {
            window.clearInterval(patchInterval);
        }
    }, 200);

    window.setTimeout(() => {
        window.clearInterval(patchInterval);
    }, 10000);
})();

(function() {
    const revealProductTemplate = () => {
        const productTemplate = document.getElementById('productTemplate');
        if (!productTemplate) return;

        productTemplate.style.opacity = '1';
    };

    const patchProductBuyBox = () => {
        if (!window.eHS || !window.eHS.productBuyBox) return false;

        const buyBox = window.eHS.productBuyBox;
        if (buyBox.__pdpRenderPatched) return true;

        if (typeof buyBox.updateOptionButtons === 'function') {
            const originalUpdateOptionButtons = buyBox.updateOptionButtons;
            buyBox.updateOptionButtons = function() {
                try {
                    return originalUpdateOptionButtons.apply(this, arguments);
                } catch (error) {
                    console.error('Product buy box updateOptionButtons failed.', error);
                    revealProductTemplate();
                    return undefined;
                }
            };
        }

        if (typeof buyBox.initProductData === 'function') {
            const originalInitProductData = buyBox.initProductData;
            buyBox.initProductData = function() {
                try {
                    return originalInitProductData.apply(this, arguments);
                } catch (error) {
                    console.error('Product buy box initProductData failed.', error);
                    revealProductTemplate();
                    return undefined;
                }
            };
        }

        buyBox.__pdpRenderPatched = true;
        return true;
    };

    if (!document.getElementById('productTemplate')) return;

    if (!patchProductBuyBox()) {
        const patchInterval = window.setInterval(() => {
            if (patchProductBuyBox()) {
                window.clearInterval(patchInterval);
            }
        }, 200);

        window.setTimeout(() => {
            window.clearInterval(patchInterval);
        }, 10000);
    }

    window.setTimeout(() => {
        const productTemplate = document.getElementById('productTemplate');
        if (!productTemplate) return;

        if (window.getComputedStyle(productTemplate).opacity === '0') {
            revealProductTemplate();
        }
    }, 2500);
})();

(function() {
    const AVAILABLE_LABEL = 'Add To Cart';
    const SOLD_OUT_LABEL = 'Sold Out';
    const PDP_ROOT_SELECTOR = '[data-pdp-buybox]';
    const QUICKVIEW_ROOT_ID = 'productQuickViewTemplate';

    const setButtonLabel = (button, label) => {
        if (!button) return;

        if (button.tagName === 'INPUT') {
            button.value = label;
            return;
        }

        button.textContent = label;
    };

    const syncButtonsInRoot = (root, isAvailable) => {
        if (!root) return;

        const buttons = Array.from(root.querySelectorAll('[data-add-to-cart]'));
        buttons.forEach((button) => {
            const klaviyoBis = button.parentElement
                ? button.parentElement.querySelector('[data-add-to-cart] ~ [data-klaviyo-bis]')
                : null;

            button.disabled = !isAvailable;
            button.setAttribute('aria-disabled', String(!isAvailable));
            button.classList.remove('hidden');

            if (button.style && button.style.display === 'none') {
                button.style.display = '';
            }

            setButtonLabel(button, isAvailable ? AVAILABLE_LABEL : SOLD_OUT_LABEL);

            if (klaviyoBis) {
                klaviyoBis.style.display = 'none';
                klaviyoBis.classList.add('hidden');
            }
        });
    };

    const syncPdpButtons = (buyBox) => {
        const isAvailable = Boolean(buyBox && buyBox.currentVariant && buyBox.currentVariant.available);
        const pdpRoot = document.querySelector(PDP_ROOT_SELECTOR);
        const stickyRoot = document.querySelector('[data-pdp-sticky-atc]');

        syncButtonsInRoot(pdpRoot, isAvailable);
        syncButtonsInRoot(stickyRoot, isAvailable);
    };

    const syncQuickviewButtons = (buyBox) => {
        const isAvailable = Boolean(buyBox && buyBox.currentVariant && buyBox.currentVariant.available);
        const quickviewRoot = buyBox && buyBox.mainWrapper ? buyBox.mainWrapper : document.getElementById(QUICKVIEW_ROOT_ID);

        syncButtonsInRoot(quickviewRoot, isAvailable);
    };

    const ensureAllOosFormVisible = (buyBox, formId) => {
        if (!formId || !buyBox || !Array.isArray(buyBox.product && buyBox.product.variants) || !buyBox.product.variants.length) {
            return;
        }

        const hasAvailableVariant = buyBox.product.variants.some((variant) => variant && variant.available);
        if (hasAvailableVariant) {
            return;
        }

        const form = document.getElementById(formId);
        if (form) {
            form.classList.remove('hidden');
        }
    };

    const patchBuyBox = (propertyName, syncButtons, formId) => {
        if (!window.eHS || !window.eHS[propertyName]) return false;

        const buyBox = window.eHS[propertyName];
        if (buyBox.__oosButtonPatchApplied) {
            return true;
        }

        if (typeof buyBox.updateVariantInfo === 'function') {
            const originalUpdateVariantInfo = buyBox.updateVariantInfo;
            buyBox.updateVariantInfo = function() {
                const result = originalUpdateVariantInfo.apply(this, arguments);
                syncButtons(this);
                return result;
            };
        }

        if (typeof buyBox.addToCart === 'function') {
            const originalAddToCart = buyBox.addToCart;
            buyBox.addToCart = function(event) {
                const isAvailable = Boolean(this.currentVariant && this.currentVariant.available);

                if (!isAvailable) {
                    if (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }

                    syncButtons(this);
                    return false;
                }

                return originalAddToCart.apply(this, arguments);
            };
        }

        if (typeof buyBox.fullyDisableATC === 'function') {
            const originalFullyDisableATC = buyBox.fullyDisableATC;
            buyBox.fullyDisableATC = function() {
                const result = originalFullyDisableATC.apply(this, arguments);
                ensureAllOosFormVisible(this, formId);
                syncButtons(this);
                return result;
            };
        }

        ensureAllOosFormVisible(buyBox, formId);

        if (buyBox.currentVariant) {
            syncButtons(buyBox);
        }

        buyBox.__oosButtonPatchApplied = true;
        return true;
    };

    const patchBuyBoxes = () => {
        const pdpPatched = patchBuyBox('productBuyBox', syncPdpButtons, 'productForm');
        const quickviewPatched = patchBuyBox('quickviewProductBuyBox', syncQuickviewButtons, 'productFormQuickView');

        return pdpPatched || quickviewPatched;
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-add-to-cart]');
        if (!trigger) return;

        if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);

    document.addEventListener('buybox:variantChanged', () => {
        if (window.eHS && window.eHS.productBuyBox) {
            window.setTimeout(() => syncPdpButtons(window.eHS.productBuyBox), 0);
        }
    });

    if (patchBuyBoxes()) return;

    const patchInterval = window.setInterval(() => {
        if (patchBuyBoxes()) {
            window.clearInterval(patchInterval);
        }
    }, 200);

    window.setTimeout(() => {
        window.clearInterval(patchInterval);
    }, 10000);
})();

// Product Gallery Swiper
(function() {
    let productGallerySwiper = null;
    let isInitializing = false;
    let reinitTimeout = null;
    let galleryHeightTimeout = null;
    let galleryObserver = null;
    let buyboxResizeObserver = null;
    let observedMainSlides = null;
    let lastObservedImageCount = 0;

    const getGalleryRoot = () => {
        const galleries = Array.from(document.querySelectorAll('[data-pg]'));
        return galleries.find((gallery) => !gallery.closest('#productQuickViewTemplate')) || null;
    };

    const getMainSlides = () => {
        const galleryRoot = getGalleryRoot();
        return galleryRoot ? galleryRoot.querySelector('[data-pg-main-slides]') : null;
    };

    const getThumbSlides = () => {
        const galleryRoot = getGalleryRoot();
        return galleryRoot ? galleryRoot.querySelector('[data-pg-thumb-slides]') : null;
    };

    const getModelInfoEl = () => {
        const galleryRoot = getGalleryRoot();
        return galleryRoot ? galleryRoot.querySelector('[data-pg-model-info]') : null;
    };

    const getGalleryImageCount = (mainSlides) => {
        if (!mainSlides) return 0;
        return mainSlides.querySelectorAll('.product-image').length;
    };

    const isSwiperReady = (mainSlides) => {
        if (!mainSlides || !productGallerySwiper) return false;
        return Boolean(mainSlides.querySelector('.swiper-wrapper') && mainSlides.querySelector('.swiper-slide'));
    };

    const getGallerySlides = (mainSlides) => {
        if (!mainSlides) return [];
        return Array.from(mainSlides.querySelectorAll('.product-image, .product-video'));
    };

    const hasBuiltGalleryImages = (mainSlides) => {
        if (!mainSlides) return false;
        return mainSlides.querySelector('.product-image') !== null;
    };

    const syncPdpGalleryHeight = () => {
        const productTemplate = document.getElementById('productTemplate');
        if (!productTemplate) return;

        const galleryColumn = productTemplate.querySelector('.ns-pdp-gallery-column');
        const buybox = productTemplate.querySelector('.ns-pdp-buybox-column > [data-pdp-buybox]');
        if (!galleryColumn || !buybox) return;

        if (!window.matchMedia('(min-width: 768px)').matches) {
            galleryColumn.style.removeProperty('--pdp-buybox-height');
            return;
        }

        galleryColumn.style.setProperty('--pdp-buybox-height', `${buybox.getBoundingClientRect().height}px`);

        if (productGallerySwiper && typeof productGallerySwiper.update === 'function') {
            productGallerySwiper.update();
        }
    };

    const observePdpBuyboxHeight = () => {
        if (typeof ResizeObserver === 'undefined') return;

        const buybox = document.querySelector('#productTemplate .ns-pdp-buybox-column > [data-pdp-buybox]');
        if (!buybox) return;

        if (buyboxResizeObserver) {
            buyboxResizeObserver.disconnect();
        }

        buyboxResizeObserver = new ResizeObserver(() => {
            syncPdpGalleryHeight();
        });
        buyboxResizeObserver.observe(buybox);
    };

    const observeGallerySlides = () => {
        const mainSlides = getMainSlides();

        if (!mainSlides || observedMainSlides === mainSlides) return;

        if (galleryObserver) {
            galleryObserver.disconnect();
        }

        observedMainSlides = mainSlides;
        lastObservedImageCount = getGalleryImageCount(mainSlides);
        galleryObserver = new MutationObserver(() => {
            const currentImageCount = getGalleryImageCount(mainSlides);

            if (currentImageCount === lastObservedImageCount) return;

            lastObservedImageCount = currentImageCount;

            if (currentImageCount > 0) {
                scheduleSwiperInit(0, 80);
            }
        });

        galleryObserver.observe(mainSlides, {
            childList: true,
            subtree: true
        });
    };

    const scheduleSwiperInit = (attempt = 0, initialDelay = 150) => {
        clearTimeout(reinitTimeout);
        reinitTimeout = setTimeout(() => {
            const mainSlides = getMainSlides();
            const gallerySlides = getGallerySlides(mainSlides);

            observeGallerySlides();

            if (isSwiperReady(mainSlides)) {
                syncActiveGalleryState(mainSlides);
                return;
            }

            if (!mainSlides || !gallerySlides.length || !hasBuiltGalleryImages(mainSlides)) {
                if (attempt < 20) {
                    scheduleSwiperInit(attempt + 1, 100);
                }
                return;
            }

            initProductGallerySwiper();
        }, attempt === 0 ? initialDelay : 100);
    };

    const unwrapSwiperSlides = (mainSlides) => {
        if (!mainSlides) return;

        const swiperWrapper = mainSlides.querySelector('.swiper-wrapper');
        if (!swiperWrapper) return;

        const wrapperSlides = Array.from(swiperWrapper.children).filter((child) =>
            child.classList.contains('product-image') || child.classList.contains('product-video')
        );

        wrapperSlides.forEach((slide) => {
            slide.classList.remove(
                'swiper-slide',
                'swiper-slide-active',
                'swiper-slide-next',
                'swiper-slide-prev',
                'swiper-slide-visible',
                'swiper-slide-fully-visible'
            );
            mainSlides.insertBefore(slide, swiperWrapper);
        });

        swiperWrapper.remove();
    };

    const inferVideoProvider = (iframe) => {
        if (!iframe) return null;

        if (iframe.dataset.videoProvider) {
            return iframe.dataset.videoProvider;
        }

        const src = iframe.getAttribute('src') || '';
        if (src.indexOf('youtube.com/embed/') !== -1) {
            return 'youtube';
        }

        if (src.indexOf('player.vimeo.com/video/') !== -1 || src.indexOf('vimeo.com/') !== -1) {
            return 'vimeo';
        }

        return null;
    };

    const pauseEmbeddedVideo = (iframe, provider) => {
        if (!iframe || !provider || !iframe.contentWindow) return;

        if (provider === 'youtube') {
            iframe.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: []
            }), '*');
        }

        if (provider === 'vimeo') {
            iframe.contentWindow.postMessage(JSON.stringify({
                method: 'pause'
            }), '*');
        }
    };

    const pauseGalleryVideoContainer = (container) => {
        if (!container) return;

        const htmlVideo = container.querySelector('video');
        const iframe = container.querySelector('iframe');
        const provider = inferVideoProvider(iframe);

        if (htmlVideo && !htmlVideo.paused) {
            htmlVideo.pause();
        }

        if (iframe) {
            pauseEmbeddedVideo(iframe, provider);
        }

        container.classList.remove('is-playing');
        container.dataset.videoPlaying = 'false';
    };

    const pauseInactiveGalleryVideos = (mainSlides, activeSlide) => {
        if (!mainSlides) return;

        const containers = new Set();
        mainSlides.querySelectorAll('.swiper-slide.product-video, .swiper-slide .product-video').forEach((container) => {
            containers.add(container.classList.contains('swiper-slide') ? container : container.closest('.product-video'));
        });

        containers.forEach((container) => {
            if (!container) return;

            const parentSlide = container.classList.contains('swiper-slide') ? container : container.closest('.swiper-slide');
            if (parentSlide === activeSlide) return;

            pauseGalleryVideoContainer(container);
        });
    };

    const teardownProductGallerySwiper = () => {
        clearTimeout(reinitTimeout);

        const mainSlides = getMainSlides();
        if (!mainSlides) return;

        pauseInactiveGalleryVideos(mainSlides, null);

        // Hide gallery during teardown to prevent CLS
        const galleryRoot = getGalleryRoot();
        if (galleryRoot) {
            galleryRoot.removeAttribute('data-gallery-ready');
            galleryRoot.classList.add('opacity-0');
        }

        if (productGallerySwiper) {
            productGallerySwiper.destroy(true, true);
            productGallerySwiper = null;
        }

        unwrapSwiperSlides(mainSlides);
        window.productGallerySwiper = null;
    };

    const syncActiveGalleryState = (mainSlides) => {
        if (!mainSlides) return;

        const thumbSlides = getThumbSlides();
        const slides = mainSlides.querySelectorAll('.swiper-slide');
        const activeSlide = mainSlides.querySelector('.swiper-slide-active') || slides[0];

        slides.forEach((slide) => {
            slide.classList.toggle('active', slide === activeSlide);
        });

        pauseInactiveGalleryVideos(mainSlides, activeSlide);

        if (!activeSlide || !thumbSlides) return;

        const originIndex = activeSlide.dataset.originIndex;
        thumbSlides.querySelectorAll('.thumbnail').forEach((thumb) => {
            thumb.classList.toggle('active', thumb.dataset.originIndex === originIndex);
        });

        const modelInfo = activeSlide.dataset.modelInfo;
        const modelInfoEl = getModelInfoEl();
        if (modelInfoEl) {
            modelInfoEl.innerHTML = modelInfo ? decodeURI(modelInfo) : '';
        }
    };

    const initProductGallerySwiper = () => {
        if (isInitializing) return;
        isInitializing = true;

        try {
            const mainSlides = getMainSlides();

            if (!mainSlides) {
                return;
            }

            const gallerySlides = getGallerySlides(mainSlides);
            if (!gallerySlides.length || !hasBuiltGalleryImages(mainSlides)) {
                return;
            }

            observeGallerySlides();

            // Destroy existing swiper if it exists
            if (productGallerySwiper) {
                teardownProductGallerySwiper();
            }

            // Check if there are slides to show
            let swiperWrapper = mainSlides.querySelector('.swiper-wrapper');

            // If swiper-wrapper doesn't exist, create it and move slides into it
            if (!swiperWrapper) {
                swiperWrapper = document.createElement('div');
                swiperWrapper.className = 'swiper-wrapper';

                // Insert swiper-wrapper at the beginning of mainSlides first
                mainSlides.insertBefore(swiperWrapper, mainSlides.firstChild);

                // Create pagination if it doesn't exist
                if (!mainSlides.querySelector('.swiper-pagination')) {
                    const pagination = document.createElement('div');
                    pagination.className = 'swiper-pagination';
                    mainSlides.appendChild(pagination);
                }
            }

            // Move any slides that are direct children of mainSlides into swiper-wrapper
            const slidesOutsideWrapper = Array.from(mainSlides.children).filter(child => 
                (child.classList.contains('product-image') || child.classList.contains('product-video')) &&
                child.parentElement === mainSlides
            );

            slidesOutsideWrapper.forEach(slide => {
                slide.classList.add('swiper-slide');
                swiperWrapper.appendChild(slide);
            });

            // Ensure all slides inside wrapper have swiper-slide class
            const slidesInsideWrapper = swiperWrapper.querySelectorAll('.product-image, .product-video');
            slidesInsideWrapper.forEach(slide => {
                if (!slide.classList.contains('swiper-slide')) {
                    slide.classList.add('swiper-slide');
                }
            });

            if (swiperWrapper.children.length === 0) {
                return;
            }

            const slideCount = swiperWrapper.children.length;
            mainSlides.classList.toggle('pdp-gallery__main--single', slideCount === 1);
            mainSlides.classList.toggle('pdp-gallery__main--two-up', slideCount === 2);
            mainSlides.classList.toggle('pdp-gallery__main--split', slideCount > 2);

            // Initialize Swiper
            productGallerySwiper = new Swiper(mainSlides, {
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: mainSlides.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: mainSlides.querySelector('[data-pg-nav-prev]'),
                    nextEl: mainSlides.querySelector('[data-pg-nav-next]'),
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: slideCount > 1 ? 4 : 0,
                    }
                },
                on: {
                    init: function() {
                        syncActiveGalleryState(mainSlides);
                        // Reveal gallery now that Swiper is ready
                        const galleryRoot = getGalleryRoot();
                        if (galleryRoot) {
                            galleryRoot.setAttribute('data-gallery-ready', '');
                            galleryRoot.classList.remove('opacity-0');
                        }
                    },
                    slideChange: function() {
                        syncActiveGalleryState(mainSlides);
                    }
                }
            });

            // Expose swiper instance globally for productGalleryNew to use
            window.productGallerySwiper = productGallerySwiper;
            syncActiveGalleryState(mainSlides);
        } finally {
            isInitializing = false;
        }
    };

    // Handle thumbnail clicks to sync with swiper
    const bindThumbnailClicks = () => {
        const thumbSlides = getThumbSlides();
        if (!thumbSlides) return;

        thumbSlides.addEventListener('click', (e) => {
            const thumb = e.target.closest('.thumbnail');
            if (!thumb || !window.productGallerySwiper) return;

            const originIndex = thumb.dataset.originIndex;
            const mainSlides = getMainSlides();
            if (!mainSlides) return;

            const slides = mainSlides.querySelectorAll('.swiper-slide');
            
            slides.forEach((slide, index) => {
                if (slide.dataset.originIndex === originIndex) {
                    window.productGallerySwiper.slideTo(index);
                }
            });
        });
    };

    const bindColorOptionClicks = () => {
        document.addEventListener('click', (event) => {
            const colorOption = event.target.closest('[data-color-option]');
            if (!colorOption) return;

            teardownProductGallerySwiper();
            scheduleSwiperInit(0, 325);
        }, true);
    };

    const bindGalleryHeightSync = () => {
        window.addEventListener('resize', () => {
            clearTimeout(galleryHeightTimeout);
            galleryHeightTimeout = setTimeout(syncPdpGalleryHeight, 120);
        });
    };

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            syncPdpGalleryHeight();
            observePdpBuyboxHeight();
            observeGallerySlides();
            bindThumbnailClicks();
            bindColorOptionClicks();
            bindGalleryHeightSync();
            scheduleSwiperInit();
        });
    } else {
        syncPdpGalleryHeight();
        observePdpBuyboxHeight();
        observeGallerySlides();
        bindThumbnailClicks();
        bindColorOptionClicks();
        bindGalleryHeightSync();
        scheduleSwiperInit();
    }
})();
